import { Component, ViewChild, Input, Output, OnChanges, OnInit, AfterViewInit  } from '@angular/core';
import { ClrWizard } from '@clr/angular';
import { Router, ActivatedRoute } from '@angular/router';
import GatewayDto  from '../dto/gateway-dto';
import { EdgeInterfaceDto, RoutingConfigDto, GatewayCliSettingsDto } from '../dto/gateway-dto';
import { GatewayService }  from '../gateway.service';
import { NetworkService }  from '../../networks/network.service';
import { Observable }  from 'rxjs/Observable';
import { Subscription } from 'rxjs/Rx';
import { Response } from '@angular/http';
const _ = require('lodash');

@Component({
  selector: 'add-edit-gateway-wizard',
  template: require('./add-edit-gateway-wizard.html'),
  styles: [require('./add-edit-gateway-wizard.scss')]
})

export default class AddEditGatewayWizard implements OnInit, AfterViewInit {
    private showWizard: boolean = false;
    private gateway: GatewayDto = new GatewayDto();
    private vcContainers: any;
    private subscribeHandler: Subscription;
    private showInterfaceDialog: boolean = false;
    private selectedInterface: EdgeInterfaceDto = null;
    private interfaceForAddEdit: EdgeInterfaceDto = null;
    private showDeleteInterfaceDialog: boolean = false;
    private interfaceOperationMode: string = 'ADD';
    private subscribeParamHandler: Subscription;
    private operationMode: string = 'ADD';
    private isEditMode: boolean = false;
    private title: string = 'Configure Router';
    private isDescriptionPageValid: boolean = false;
    private isCliSettingsPageValid: boolean = true;
    private hasValidInterfaces: boolean = false;
    private finishDisabled: boolean = false;
    private operationFailed: boolean = false;
    private errorMessage: string = '';
    private routeSettingsChanged: boolean = false;
    private routingConfig: any;
    private networkOperationInProgress: boolean = false;
    private addressGroups: any[] = [];
    private network: any = null;
    private isDeleteTrunk: boolean = false;

    private deploymentConfigurationInvalid: boolean = false;

    private skipCliSettingsStep: boolean = false;
    private skipDefaultGwSettingsStep: boolean = false;

    @ViewChild('wizard') wizard: ClrWizard;

    constructor (private router: Router, private gatewayService: GatewayService, private networkService: NetworkService,
    private activatedRoute: ActivatedRoute) {
        this.gateway.interfaces = new Array<EdgeInterfaceDto>();
        networkService.getAllNetworks();
    }

    ngOnInit() {
        this.showDeleteInterfaceDialog = false;
        this.subscribeParamHandler = this.activatedRoute.params.subscribe(params => {
            let id = params['id'];
            if (id) {
                this.isEditMode = true;
                this.getGateway(id);
                this.showWizard = true;
                this.getAllVcContainer();
                this.title = 'Edit Router';
                this.operationMode = 'EDIT';
                this.skipCliSettingsStep = true;
                this.skipDefaultGwSettingsStep = true;
            } else {
                this.routingConfig = new RoutingConfigDto();
                this.showWizard = true;
                this.skipCliSettingsStep = false;
                this.skipDefaultGwSettingsStep = false;
                this.getAllVcContainer();
            }
        });
    }

    getGateway(objectId) {
        let me = this;
        this.subscribeHandler = this.gatewayService.getGateway(objectId)
        .subscribe(
            (gateway: any) => {
                this.gateway = gateway;
                this.gateway.interfaces = this.arrangeInterfaceItems(this.gateway.interfaces);
                if (this.gateway.routingConfig) {
                    this.routingConfig = this.gateway.routingConfig;
                } else {
                    this.routingConfig = new RoutingConfigDto();
                }
                if (this.gateway.interfaces) {
                    for (let edgeInterface of this.gateway.interfaces){
                        if (edgeInterface.isConnected) {
                            this.hasValidInterfaces = true;
                            break;
                        }
                    }
                }
            }
        );
    }

    wizardStateChanged(isItOpen) {
        if (!isItOpen) {
             this.router.navigate(['services/networking/gateways']);
        }
    }

    onDescribePageCommited(event): void {
       this.wizard.next();
    }

    onCliSettingsPageCommited(event): void {
        if (this.gateway.cliSettings.password) {
            // validate the password
            this.networkOperationInProgress = true;
            this.subscribeHandler = this.gatewayService.validateEdgeCliCredentials(this.vcContainers[0].scopeId,
            this.gateway.cliSettings)
            .subscribe (
                success => {
                    this.operationFailed = false;
                    this.networkOperationInProgress = false;
                    this.errorMessage = '';
                    // this.wizard.next();
                },
                error => {
                    this.wizard.prev();
                    this.displayErrorOnWizard(error);
                    this.networkOperationInProgress = false;
                }
            );
        } else {
            this.wizard.next();
        }
    }

    onInterfacePageCommited(event): void {
        if (this.isEditMode) {
            this.upsertGateway();
        } else {
            this.wizard.next();
        }
    }

    getAllVcContainer() {
        this.subscribeHandler = this.gatewayService.getComputeContainer()
            .subscribe(
            containers => {
                this.vcContainers = containers;
                if (!this.isEditMode) {
                    this.gateway.scopeId = this.vcContainers[0].scopeId;
                    this.gateway.edgeVmSize = 'compact';
                    this.gateway.haSettings.enabled = false;
                }
            }
        );
    }

    getVNIC() {
        let count: number = 0;
        let interfaces = this.gateway.interfaces;
        for (let i = 0; i < interfaces.length; i++) {
            if (typeof interfaces[i].tunnelId === "undefined") {
                count++;
            }
        }
        return count;
    }

    onAddInterfaceClicked() {
        this.interfaceForAddEdit = new EdgeInterfaceDto();
        this.interfaceForAddEdit.type = 'uplink';
        this.interfaceForAddEdit.index = this.getVNIC(); //this.gateway.interfaces.length;
        this.interfaceOperationMode = 'ADD';
        this.showInterfaceDialog = true;
    }

    onEditInterfaceClicked(event) {
        this.interfaceForAddEdit = _.cloneDeep(<EdgeInterfaceDto>event.selectedInterface);
        this.interfaceOperationMode = 'EDIT';
        this.showInterfaceDialog = true;
        if (event.selectedInterface.addressGroups) {
            this.addressGroups = [].concat(_.cloneDeep(event.selectedInterface.addressGroups));
        }
        let networkId: string = event.selectedInterface.networkId ? event.selectedInterface.networkId : '';
        if (networkId && networkId.indexOf('network-') >= 0 && networkId.length === 44) {
            this.networkService.getNetwork(networkId).subscribe(
                    network => {
                        this.network = network;
                    }
                );
        }
    }

    displayDeleteInterfaceDialog(event){
        this.selectedInterface = <EdgeInterfaceDto> event.selectedInterface;
        if (typeof this.selectedInterface.type !== "undefined" && this.selectedInterface.type === 'trunk') {
            this.isDeleteTrunk = true;
        } else {
            this.isDeleteTrunk = false;
        }
        this.showDeleteInterfaceDialog = true;
    }

    deleteSubInterfaces(selectedInterface, interfaces) {
        if (selectedInterface && typeof selectedInterface.type !== "undefined" && selectedInterface.type === 'trunk') {
            let parentInterfaceIndex: number = selectedInterface.index;
            for (let i = interfaces.length -1; i >= 0; i--) {
                let currentInterface = interfaces[i];
                if (typeof currentInterface.parentInterfaceIndex !== "undefined" && currentInterface.parentInterfaceIndex === parentInterfaceIndex) {
                    interfaces.splice(i,1);
                }
            }
        }
    }

    onDeleteInterface(event) {
        let selectedIndex: number = -1;
        let __this = this;
        let actualIndex: number = -1;
        this.gateway.interfaces.forEach(function(item, index) {
            if (item === __this.selectedInterface) {
                selectedIndex = index;
                actualIndex = (item.index) ? item.index : -1 ;
            }
        })
        let index: number = this.selectedInterface.index;
        if (selectedIndex >= 0) {
            if(!this.isEditMode) {
                // Add
                let selectedInterface = _.cloneDeep (this.gateway.interfaces[selectedIndex]);
                this.gateway.interfaces.splice(selectedIndex, 1);
                this.deleteSubInterfaces(selectedInterface, this.gateway.interfaces);
            } else {
                // Edit
                // If trunk  is deleted, then delete sub interface too
                if (typeof this.selectedInterface.parentInterfaceIndex !== "undefined") {
                    // Delete selected subinterface
                    this.gateway.interfaces.splice(selectedIndex, 1);
                } else {
                    this.gateway.interfaces[selectedIndex] = this.getDummyEdgeInterface((actualIndex >= 0) ? actualIndex : selectedIndex );
                    this.deleteSubInterfaces(this.selectedInterface, this.gateway.interfaces);
                }
            }
        }
        this.showDeleteInterfaceDialog = false;
        this.gateway.interfaces = [].concat(this.gateway.interfaces);
        if(this.gateway.interfaces.length === 0) {
            this.hasValidInterfaces = false;
        } else {
            this.hasValidInterfaces = true;
        }
    }

    saveInterface(event) {
        let __this = this;
        if (this.interfaceOperationMode === 'EDIT') {
            this.gateway.interfaces.forEach(function(item, index) {
                if (item.index === event.interface.index) {
                    if (item.type === 'trunk' && event.interface.type !== 'trunk') {
                    // type change from trunk to uplink or Internal. So delete SubInterfaces
                        __this.deleteSubInterfaces(item, __this.gateway.interfaces);
                    }
                    __this.gateway.interfaces[index] = event.interface;
                }
            })
        } else {
            this.gateway.interfaces.push(event.interface);
        }
        this.gateway.interfaces = this.arrangeInterfaceItems(this.gateway.interfaces);
        this.showInterfaceDialog = false;
        this.hasValidInterfaces = false;
        for (let edgeInterface of this.gateway.interfaces) {
            if (edgeInterface.isConnected) {
                this.hasValidInterfaces = true;
                break;
            }
        }
    }

    arrangeInterfaceItems(allInterfaces: Array<any>) {
        if (allInterfaces.length === 0) {
            return;
        }
        let interfaceList = [];
        let subInterfaceList = [];
        let completeList = [];
        allInterfaces.forEach(function(item) {
            if (item.type) {
                interfaceList.push (item);
            } else {
                subInterfaceList.push (item);
            }
        })
        if (interfaceList.length === 0) {
            return allInterfaces;
        }
        interfaceList.forEach(function(itemInterface) {
            completeList.push (itemInterface);
            if (itemInterface.type === 'trunk') {
                subInterfaceList.forEach(function(itemSubInterface) {
                    if (itemInterface.index === itemSubInterface.parentInterfaceIndex) {
                        completeList.push (itemSubInterface);
                    }
                });
            }
        })

        if (allInterfaces.length === completeList.length) {
            // make sure that not missing any item
            return completeList;
        }
            return allInterfaces;
    }

    cancelInterfaceDialog(event){
        this.showInterfaceDialog = false;
    }

    onFinish(event) {
       this.upsertGateway();
    }

    upsertGateway() {
        let payload;
        this.finishDisabled = true;
        this.networkOperationInProgress = true;
        if (this.gateway.cliSettings){
            if (this.gateway.cliSettings.password === '' || this.gateway.cliSettings.userName === '') {
                this.gateway.cliSettings = new GatewayCliSettingsDto();
            }
        }
        if (this.operationMode === 'ADD') {
            if (this.routeSettingsChanged) {
                this.gateway.routingConfig = this.routingConfig;
            } else {
                if (this.gateway.routingConfig) {
                    delete this.gateway.routingConfig;
                }
            }
            payload = this.removeUnsuedAttributes(_.cloneDeep(this.gateway));
            this.subscribeHandler = this.gatewayService.createGateway(payload)
                .subscribe(
                gateway => {
                    this.removeErrorFromWizard();
                    this.gatewayService.getAllGateways();
                    this.wizard.close();
                    this.router.navigate(['services/networking/gateways']);
                },
                error => this.displayErrorOnWizard(error)
                );
        } else {
            payload = this.removeUnsuedAttributes(_.cloneDeep(this.gateway));
            this.subscribeHandler = this.gatewayService.updateGateway(payload)
                .subscribe(
                gateway => {
                    this.removeErrorFromWizard();
                    this.gatewayService.getAllGateways();
                    this.wizard.close();
                    this.router.navigate(['services/networking/gateways']);
                },
                error => this.displayErrorOnWizard(error)
                );
        }
    }

    removeUnsuedAttributes(gateway) {
        let interfaceItem;
        for (let i = 0; i < gateway.interfaces.length; i++) {
            interfaceItem = gateway.interfaces[i];
            if (typeof interfaceItem.isNew !== "undefined") {
                if (interfaceItem.isNew &&
                    typeof interfaceItem.parentInterfaceIndex !== "undefined" &&
                    interfaceItem.index) {
                        delete gateway.interfaces[i].index;
                }
                delete interfaceItem.isNew;
            }

            if (typeof interfaceItem.parentInterfaceIndex !== "undefined") {
                if (typeof interfaceItem.type !== "undefined") {
                    delete gateway.interfaces[i].type;
                }
            }
            if (typeof interfaceItem.networkName !== "undefined") {
                delete gateway.interfaces[i].networkName;
            }
        }
        return gateway;
    }

    displayErrorOnWizard(error: Response) {
        // display error on the wizard page;
        this.finishDisabled = false;
        this.networkOperationInProgress = false;
        this.operationFailed = true;
    }

    removeErrorFromWizard(): void {
        this.networkOperationInProgress = false;
        this.operationFailed = false;
        this.errorMessage = '';
    }

    ngAfterViewInit() {
        if (this.isEditMode) {
            this.skipPagesForEditMode();
        }
    }

    skipPagesForEditMode() {
        this.skipCliSettingsStep = true;
        this.skipDefaultGwSettingsStep = true;
    }

    onDescriptionStepValid(event) {
        this.isDescriptionPageValid = event.isValid;
    }

    onCliSettingsStepValid(event) {
        this.isCliSettingsPageValid = event.isValid;
    }

    onGatewayInterfacesConfigured(event) {
        this.hasValidInterfaces = event.hasValidInterfaces;
    }

    onRouteSettingsChanged(event) {
        this.routeSettingsChanged = event.routeSettingsChanged;
    }

    onDefaultSettingStepValid(event) {
        this.finishDisabled = !event.isValid;
    }

    getDummyEdgeInterface(index) : EdgeInterfaceDto {
        let edgeInterface:EdgeInterfaceDto = new EdgeInterfaceDto();
        edgeInterface.index = index;
        edgeInterface.addressGroups = [];
        edgeInterface.name = 'vnic' + index;
        edgeInterface.isConnected = false;
        edgeInterface.type = 'internal';
        return edgeInterface;
    }

    onNoDeploymentContainerFound(event) : void { 
        this.deploymentConfigurationInvalid = true;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/networking/networking-vc/gateways/dialogs/add-edit-gateway-wizard.component.ts